import defaultSettings from '@/settings'
import { useDynamicTitle } from '@/utils/dynamicTitle'
import { getTheme } from '@/api/theme'
import { applyTheme, cacheTheme, getCachedTheme, normalizeTheme } from '@/utils/theme'

const { sideTheme, showSettings, topNav, tagsView, tagsIcon, fixedHeader, sidebarLogo, dynamicTitle, footerVisible, footerContent } = defaultSettings

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || {}
const cachedTheme = getCachedTheme()
applyTheme(cachedTheme)
const state = {
  title: '',
  theme: cachedTheme.primaryColor,
  themeConfig: cachedTheme,
  sideTheme: cachedTheme.sideTheme || sideTheme,
  showSettings: showSettings,
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  tagsIcon: storageSetting.tagsIcon === undefined ? tagsIcon : storageSetting.tagsIcon,
  fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
  sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
  dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
  footerVisible: storageSetting.footerVisible === undefined ? footerVisible : storageSetting.footerVisible,
  footerContent: footerContent
}
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  SET_THEME_CONFIG: (state, themeConfig) => {
    const normalizedTheme = normalizeTheme(themeConfig)
    state.themeConfig = normalizedTheme
    state.theme = normalizedTheme.primaryColor
    state.sideTheme = normalizedTheme.sideTheme
  }
}

const actions = {
  // 修改布局设置
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
    if (data.key === 'theme' || data.key === 'sideTheme') {
      const themeConfig = cacheTheme({
        primaryColor: data.key === 'theme' ? data.value : state.theme,
        sideTheme: data.key === 'sideTheme' ? data.value : state.sideTheme
      })
      applyTheme(themeConfig)
      commit('SET_THEME_CONFIG', themeConfig)
    }
  },
  loadTheme({ commit }) {
    applyTheme(state.themeConfig)
    return getTheme().then(response => {
      const themeConfig = cacheTheme(response.data)
      applyTheme(themeConfig)
      commit('SET_THEME_CONFIG', themeConfig)
      return themeConfig
    }).catch(() => state.themeConfig)
  },
  // 设置网页标题
  setTitle({ commit }, title) {
    state.title = title
    useDynamicTitle()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

